import * as actionTypes from "./actionTypes";

const employeeReducer = (state = [], payload) => {
  switch (payload.type) {
    case actionTypes.SUBMIT_EMPLOYEE_SUCCESS:
      return [...payload.employees];

    case actionTypes.GET_EMPLOYEE_DETAILS_SUCCESS:
      return [...payload.employees];

    case actionTypes.EDIT_EMPLOYEE_SUCCESS:
      return [...payload.employees];

    case actionTypes.DELETE_EMPLOYEE_SUCCESS:
      return [...payload.employees];
    default:
      return state;
  }
};

export default employeeReducer;
